module.exports = __webpack_public_path__ + "img/oralTest_sub34.cec321cd.jpg";